import CircleLabel, { CIRCLE_SIZES, CIRCLE_COLORS } from './circle.label';

export default CircleLabel;
export { CIRCLE_COLORS, CIRCLE_SIZES };
